import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isZh = i18n.language?.startsWith('zh');

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 font-sans px-4">
      <div className="text-center space-y-6 max-w-sm w-full">

        <div className="text-[7rem] font-extrabold text-slate-100 leading-none select-none">
          404
        </div>

        <div className="-mt-4 space-y-2">
          <h1 className="text-2xl font-bold text-navy">
            {isZh ? '页面不存在' : 'ページが見つかりません'}
          </h1>
          <p className="text-sm text-slate-500 leading-relaxed">
            {isZh
              ? 'お探しのページが見つかりませんでした。URLをご確認いただくか、下のボタンからトップページへお戻りください。'
              : 'お探しのページが見つかりませんでした。\nURLをご確認いただくか、下のボタンからお戻りください。'}
          </p>
        </div>

        <div className="flex flex-col gap-3 pt-2">
          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 rounded-2xl bg-slate-100 text-slate-600 font-semibold text-sm hover:bg-slate-200 transition-all"
          >
            {isZh ? '← 返回上一页' : '← 前のページへ戻る'}
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 rounded-2xl bg-coral text-white font-bold text-sm hover:opacity-90 transition-all active:scale-[0.98]"
          >
            {isZh ? '返回首页' : 'トップページへ'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default NotFound;
